export default {
  MAIN_NAV: "MAIN_NAV",
  LANGUAGE_LOCALE: "LANGUAGE_LOCALE",
  SETTINGS: "SETTINGS",
  SHOW_ONBOARDING: "SHOW_ONBOARDING",
  LOGIN_TYPE: "LOGIN_TYPE",
  SSO_LOGOUT_URL: "SSO_LOGOUT_URL",
  ANNOUNCEMENTS: "ANNOUNCEMENTS",
  CHUNK_FAILED: "CHUNK_FAILED",
  PAYMENT_STATUS: "PAYMENT_STATUS",
  PAYMENT_STATUS_OTHER_PROVIDERS: "PAYMENT_STATUS_OTHER_PROVIDERS",
  UPDATE_CARD_STATUS: "UPDATE_CARD_STATUS",
  EXTERNAL_SIGNIN_SIGNUP: "EXTERNAL_SIGNIN_SIGNUP",
  UPDATE_PASSWORD_TOKEN: "UPDATE_PASSWORD_TOKEN",
  PUBLIC_COURSE: "PUBLIC_COURSE",
  PENDING_CATALOG_ENROLLMENT: "PENDING_CATALOG_ENROLLMENT",
  LEARNER_NAVIGATION_TIP: "LEARNER_NAVIGATION_TIP",
  LEARNER_UNIT_NAVIGATION_TIP: "LEARNER_UNIT_NAVIGATION_TIP",
  SHOW_TRIAL_ENDING_MODAL: "SHOW_TRIAL_ENDING_MODAL",
  CONSENT_MODAL_TIMER: "CONSENT_MODAL_TIMER",
  PRODUCT_FRUITS_TOUR_RUNNING: "PF_TOUR_RUNNING",
  PRODUCT_FRUITS_HAS_CLICKED_TOGGLE_BUTTON: "PF_HAS_CLICKED_TOGGLE_BUTTON",
  ACCESS_TOKEN: "access_token",
  REFRESH_TOKEN: "refresh_token",
  DEFAULT_ROLE: "default_role",
};
